import { Configuration, LogLevel } from '@azure/msal-browser';

export const tenantName = import.meta.env.VITE_AZURE_B2C_TENANT_NAME || '';
export const primaryUserFlow = import.meta.env.VITE_AZURE_B2C_PRIMARY_USER_FLOW || '';
export const clientId = import.meta.env.VITE_AZURE_B2C_CLIENT_ID || '';
// For B2C, the authority should include the tenant and policy
export const authority = `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${primaryUserFlow}`;
export const domain = `${tenantName}.b2clogin.com`;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || '',
    authority: authority || '',
    knownAuthorities: [domain || ''],
    redirectUri: `${window.location.origin}/admin/auth/callback/azure-ad-b2c`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message); // eslint-disable-line no-console
            return;
          case LogLevel.Info:
            console.info(message); // eslint-disable-line no-console
            return;
          case LogLevel.Verbose:
            console.debug(message); // eslint-disable-line no-console
            return;
          case LogLevel.Warning:
            console.warn(message); // eslint-disable-line no-console
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [clientId, 'offline_access', 'openid'],
  authority,
  // Explicitly add the policy parameter for B2C
  extraQueryParameters: {
    p: primaryUserFlow,
  },
};
